export const SET_PARTNER_PAYMENTS_LIST = "SET_PARTNER_PAYMENTS_LIST";
export const SET_PARTNER_PAYMENTS_LIST_ALL = "SET_PARTNER_PAYMENTS_LIST_ALL";
export const SET_PARTNER_PAYMENT_DATA = "SET_PARTNER_PAYMENT_DATA";
export const SET_FILTER_INITIAL_DATE = "SET_FILTER_INITIAL_DATE";
export const SET_FILTER_FINAL_DATE = "SET_FILTER_FINAL_DATE";
export const SET_FILTER_PAYMENT_INITIAL_DATE = "SET_FILTER_PAYMENT_INITIAL_DATE";
export const SET_FILTER_PAYMENT_FINAL_DATE = "SET_FILTER_PAYMENT_FINAL_DATE";
export const SET_FILTER_CARD_BRAND = "SET_FILTER_CARD_BRAND";
export const SET_FILTER_TERMINAL_NUMBER = "SETPARTNER__FILTER_TERMINAL_NUMBER";
export const SET_FILTER_OPERATION = "SET_FILTER_OPERATION";
export const SET_FILTER_ORDINATION = "SET_FILTER_ORDINATION";
export const SET_FILTER_STATUS = "SET_FILTER_STATUS";
export const CURRENT_PAGE = "CURRENT_PAGE";
export const SET_TOTAL_RESOURCES = "SET_TOTAL_RESOURCES";
export const LIMIT_OPTIONS = "LIMIT_OPTIONS";
export const LIMIT = "LIMIT";
export const LOADING_DATA = "LOADING_DATA";
export const SET_PARTNER_PAYMENTS_SUBTOTAL = "SET_PARTNER_PAYMENTS_SUBTOTAL";
export const SET_PARTNER_PAYMENTS_SUMMARY = "SET_PARTNER_PAYMENTS_SUMMARY";
export const SET_FILTER_ACCOUNT_ID = "SET_FILTER_ACCOUNT_ID";
export const SHOW_FILTERS = "SHOW_FILTERS";
export const FILTER_PARAMS = "FILTER_PARAMS";
export const FILTER_STATUS = "FILTER_STATUS";
export const NEW_PAYMENT = "NEW_PAYMENT";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const NEW_PAYMENT_STATUS = "NEW_PAYMENT_STATUS";
export const NEW_PAYMENT_ERROR = "NEW_PAYMENT_ERROR";
export const SET_FILTER_PARTNER = "SET_FILTER_PARTNER";
